var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "1000px", persistent: "" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(" " + _vm._s(_vm.$t("message.common.imagedraw")) + " "),
          ]),
          _c("v-card-text", [
            _c("div", {
              ref: "editor",
              staticStyle: { height: "600px", width: "100%" },
            }),
          ]),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "vue-co-btn new-btn",
                  attrs: { loading: _vm.imageEditorloading },
                  on: { click: _vm.saveImage },
                },
                [_vm._v(" " + _vm._s(_vm.$t("message.common.save")) + " ")]
              ),
              _c(
                "v-btn",
                { staticClass: "vue-co-btn new-btn", on: { click: _vm.close } },
                [_vm._v(" " + _vm._s(_vm.$t("message.common.cancel")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }